<template>
  <v-layout
    align-center
    wrap
    justify-space-between
  >
    <v-flex
      md6
      sm12
      class="pr-1"
    >
      <v-layout
        column
        align-center
      >
        <v-layout class="align-center">
          <v-flex shrink>
            <baseIcon
              :width="30"
              :height="30"
            >
              <questionIcon :icon-color="$vuetify.theme.sz_grafit" />
            </baseIcon>
          </v-flex>
          <v-flex
            shrink
            ml-3
          >
            <p
              v-if="previousEdition"
              class="mb-1 f-1"
            >
              {{ $t('alikes_families.p_e.title') }}
            </p>
            <p
              v-if="!previousEdition"
              class="mb-0 pt-2 f-1"
            >
              {{ $t('alikes_families.title') }}
            </p>
            <p
              v-if="!previousEdition"
              class="text-light"
            >
              {{ $t('alikes_families.subtitle') }}
            </p>
            <p
              class="mb-1 f-1"
              v-html="$t('alikes_families.browse_list')"
            />
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>
    <v-flex
      md3
      sm12
      class="pl-1"
    >
      <v-layout
        column
        class="family-item"
        align-center
      >
        <EntranceFamilyItem
          :family="currentFamily"
          :marked="false"
        >
          <template #createdBy>
            <div class="family-item__header family-item__header_single mb-2">
              <p class="mb-0">
                {{
                  previousEdition
                    ? $t('alikes_families.p_e.family_title')
                    : $t('alikes_families.submitted_by_you')
                }}
              </p>
            </div>
          </template>
        </EntranceFamilyItem>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import EntranceFamilyItem from '@/components/widgets/addFamily/familySimilar/EntranceFamilyItem';
import filters from '@/constants/filters';
import BaseIcon from '@/icons/BaseIcon';
import QuestionIcon from '@/icons/QuestionIcon';

export default {
    name: 'EntranceFamilies',
    components: { QuestionIcon, BaseIcon, EntranceFamilyItem },
    filters: {
        ...filters
    },
    props: {
        previousEdition: {
            default: false
        }
    },
    computed: {
        currentFamily () {
            return this.$store.getters['familyData/getCurrentFamily'];
        }
    }
};
</script>

<style scoped></style>
